import { EChatHintQuestionsActionTypes, TChatHintQuestionsPayload } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const setHintQuestionsHidden = actionGenerator<EChatHintQuestionsActionTypes.Hide, TChatHintQuestionsPayload>(
  EChatHintQuestionsActionTypes.Hide,
);
